import { m } from "framer-motion";

export interface Project {
  id: number;
  title: string;
  description: string;
  techStack: string[];
  url: string;
  github?: string;
}

const ProjectCard: React.FC<Project> = ({
  title,
  description,
  techStack,
  url,
  github,
}) => {
  return (
    <m.a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      layout
      className="block rounded-2xl bg-white/80 backdrop-blur-sm border border-gray-200 p-6 hover:shadow-lg hover:border-green-400 transition-all duration-300 cursor-pointer group"
    >
      <h3 className="text-left text-xl font-bold text-gray-900 group-hover:text-green-600 transition-colors font-title">
        {title}
      </h3>
      <p className="text-left text-sm text-gray-600 mt-2 leading-relaxed">
        {description}
      </p>
      <div className="flex flex-wrap gap-2 mt-4">
        {techStack.map((tech) => (
          <span
            key={tech}
            className="text-xs font-medium px-2.5 py-1 rounded-full bg-green-100 text-green-700"
          >
            {tech}
          </span>
        ))}
      </div>
      <div className="flex items-center gap-4 mt-4 pt-3 border-t border-gray-100">
        <span className="text-xs font-medium text-green-600 group-hover:underline">
          View Live &rarr;
        </span>
        {github && (
          <a
            href={github}
            target="_blank"
            rel="noopener noreferrer"
            onClick={(e) => e.stopPropagation()}
            className="text-xs font-medium text-gray-500 hover:text-gray-900 hover:underline"
          >
            GitHub
          </a>
        )}
      </div>
    </m.a>
  );
};

export default ProjectCard;
